import type { MaybeType } from "@/shared/types";

export enum PasswordRecoverySteps {
  PHONE_NUMBER_STEP = "PHONE_NUMBER_STEP",
  SMS_CODE_STEP = "SMS_CODE_STEP",
  NEW_PASSWORD_STEP = "NEW_PASSWORD_STEP",
  SUCCESS_STEP = "SUCCESS_STEP",
}

export type PasswordRecoveryState = {
  mobilePhone: MaybeType<string>;
  step: PasswordRecoverySteps;
  resendCoolDown: number;
};
